import { supabase } from "lib/supabase";


export const pricingSyncService = {
  // Fetch latest pricing from Supabase
  async fetchPricingFromSupabase() {
    try {
      const { data, error } = await supabase
        .from('pricing_plans')
        .select('*')
        .eq('is_active', true)
        .eq('id', 'paid')
        .single();

      if (error) throw error;

      if (data) {
        // console.log('Fetched pricing data from Supabase:', data);
        return data;
      }
      
      // Return null if no data
      return null;
    } catch (error) {
      console.error('Error fetching pricing from Supabase:', error);
      return null;
    }
  },

  // Subscribe to real-time pricing updates
  subscribeToPricingUpdates(callback) {
    const subscription = supabase
      .channel('pricing_updates')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'pricing_plans',
          filter: 'id=eq.paid'
        },
        (payload) => {
          // console.log('Real-time pricing update received:', payload);
          if (payload.new) {
            callback(payload.new);
          }
        }
      )
      .subscribe();

    return subscription;
  },

  // Optional: Fetch all active plans
  async fetchAllActivePlans() {
    try {
      const { data, error } = await supabase
        .from('pricing_plans')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error fetching all plans:', error);
      return [];
    }
  }
};